"use client";

import React from "react";
import Layout1 from "./CardCarousel/Layout1";
import Layout2 from "./CardCarousel/Layout2";
import Layout3 from "./CardCarousel/Layout3";
import Layout4 from "./CardCarousel/Layout4";
import Layout5 from "./CardCarousel/Layout5";
import Layout6 from "./CardCarousel/Layout6";
import Layout7 from "./CardCarousel/Layout7";

interface Picture {
  data?: {
    id?: string;
    attributes?: {
      url?: string;
      name?: string;
      alternativeText?: string;
    };
  };
}

interface CardProps {
  title?: string;
  subtitle?: string;
  description?: string;
  image?: Picture;
  pdfUrl?: string;
  solution?: string;
}

interface CardCarouselProps {
  data?: {
    title?: string;
    subtitle?: string;
    scroll?: CardProps[];
    isLive?: boolean;
    useH1Tag?: boolean;
    layout?: string;
  };
}

export default function CardCarousel({ data }: CardCarouselProps) {


  if (!data?.isLive) return null;

  const layout = data?.layout;

  if (layout === "image_with_overlay") {
    return <Layout3 data={data} />;
  }

  if (layout === "image_focus") {
    return <Layout5 data={data} />;
  }

  
  // ✅ Default fallback
  return <Layout6  />;
}
